
<template  minapp='mpx' xlang='wxml'>
  <controllable-drawer-bottom
    title="权益说明"
    show="{{show}}"
    headerStyle="{{headerStyle}}"
    iconStyle="{{iconStyle}}"
    bind:close="closeDrawer"
  >
    <view class="container">
      <text class="description">{{ descriptionContent }}</text>
    </view>
  </controllable-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { DeadLineList } from '@/utils/constants'
  import store from '@/store'
  import { trackEvent } from '@/common/track'
  // 改为免登专用

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      regularService: { // 用于区分埋点
        type: Boolean,
        value: false
      },
      // 1 免登 2 退改无忧
      serviceType: {
        type: Number,
        value: 1
      },
      page: {
        type: String,
        value: 'order'
      }
    },
    watch: {
      show: {
        handler(val) {
          if (val) {
            if (this.isMakeOrderPage) {
              trackEvent(
                'yks_train_detailpage_showfloat_sw',
                '迎客松-火车票-车次详情页-产品说明浮层-曝光',
                {
                  servicetype: 'nologin',
                  tagtype: 'null'
                }
              )
            }
            // 从填单页-可选择辅营商品-打开
            if (this.regularService) {
              trackEvent(
                'yks_train_conorder_showfloat_sw',
                '迎客松-火车票-确认订单页-产品说明浮层-曝光',
                { servicetype: 'nologin' }
              )
            }
          }
        }
      }
    },
    computed: {
      ...store.mapState({
        selectRightInfo: 'train.selectRightInfo'
      }),
      descriptionContent() {
        let text = ''
        switch (this.serviceType) {
          case 1:
            text = `1.免登录12306账号购票；\n2.全天24小时极速出票服务；\n3.24小时专人客服服务；\n4.赠2张7.5折滴滴接送站打车券，最高优惠30元，满20元可用，支持特快、特惠、优享、快车、专车，有效期7天；\n5.赠10个抢票加速包；\n6.退票或改签需至车站窗口办理；\n7.便捷服务套餐在购票成功后不支持退款。\n注：限时赠券，出票成功后自动发放，可在首页-我的-优惠券点击查看。`
            break
          case 2:
            text = `1、退改无忧包含8大专属权益：火车票退票或改签的手续费保障1次，2张7.5折接送站打车券，租车100元券，电单车购卡30元券，单车购卡5元券，拼车3元券，10个加速包，以及免登录12306账号权益；\n2、限时赠券，赠送的券包会在出票成功后自动发放，可在首页-我的-优惠券点击查看，过期后自动失效；\n3、退改手续费补偿规则：仅支持滴滴线上退票或改签补偿，暂不支持港铁理赔；提交退票时，距离发车时间48小时以上，补偿100%手续费；距离发车24-48小时内，补偿70%手续费；距离发车24小时内，补偿50%手续费，最高补偿100元。提交改签时，开车前48小时内改签至发车前列车或开车前24-48小时内改签至发车日期后的列车，补偿100%手续费，开车前24小时内，改签至发车日期后的列车，补偿50%手续费；最高赔付100元，其他场景不补偿；\n4、出票成功后，退改无忧权益立刻生效，不支持退款。\n5、系统未补偿成功可联系客服处理。`
        }
        return text
      },
      // 埋点区分页面使用
      isMakeOrderPage() {
        return this.page === 'makeOrder' && this.selectRightInfo?.length === 0
      }
    },
    data: {
      headerStyle: {
        'justify-content': 'center',
        'padding-top': '24px',
        'font-family': 'PingFangSC-Medium',
        'font-size': '18px',
        'line-height': '18px',
        color: '#000000'
      },
      iconStyle: {
        top: '20px'
      }
    },
    methods: {
      closeDrawer() {
        this.triggerEvent('close')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .container
    width 100%
    margin-top 24px
    padding 0 12px
    padding-bottom 159px
    box-sizing border-box
    .description
      font-family PingFangSC-Regular
      font-weight 400
      line-height 17px
      font-size 12px
      color #666
</style>

  
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom'
    }
  }
</script>